import { Translation } from '@ps/web-shared-components';
import { format } from 'date-fns';
import React from 'react';

import { ExclusionType } from '../../definitions';
import type { ExclusionResponseProps as Props } from '../../definitions';
import DefaultBreakResponse from '../DefaultBreakResponse/DefaultBreakResponse';

import { TXTWCL_This_means_you_wonXt_be_able_t_ELL_3 } from './ExclusionResponseCOM.messages.json';

const ExclusionResponseCOM: React.FC<Props> = ({ daysRequested, exclusionType, endDate }) => {
  if (exclusionType === ExclusionType.Break) {
    return <DefaultBreakResponse daysRequested={daysRequested} endDate={endDate} />;
  }
  return (
    <Translation
      {...TXTWCL_This_means_you_wonXt_be_able_t_ELL_3}
      values={{
        0: <b>{format(endDate, 'Pp')}</b>
      }}
    />
  );
};

export default ExclusionResponseCOM;
